enum IconSizes {
    VeryTiny = "VeryTiny",
    ExtraSmaller = "ExtraSmaller",    
    ExtraSmall = "ExtraSmall",    
    Small = "Small",
    Medium = "Medium",
    Large = "Large",
    XLarge = "XLarge",
    Zoom1x = "Zoom1x",
    Zoom2x = "Zoom2x",
    Zoom3x = "Zoom3x",
    Zoom4x = "Zoom4x",
    Zoom5x = "Zoom5x",
    Zoom6x = "Zoom6x",
    Zoom7x = "Zoom7x",
    Zoom8x = "Zoom8x",
    Zoom9x = "Zoom9x",
    Zoom10x = "Zoom10x"
};

enum IconSource {    
    FontAwesome = "FontAwesome",
    OpenIconic = "OpenIconic"
}

enum IconSet {    
    Solid = "Solid",
    Regular = "Regular",
    Brands = "Brands"
}

enum IconVariant
{
    Primary = "Primary",    
    Secondary = "Secondary",
    Success = "Success",
    Warning = "Warning",
    Danger = "Danger",
    GreyScale = "GreyScale",
    PrimaryInverse = "PrimaryInverse",    
    SecondaryInverse = "SecondaryInverse",
    SuccessInverse = "SuccessInverse",
    WarningInverse = "WarningInverse",
    DangerInverse = "DangerInverse",
    GreyScaleInverse = "GreyScaleInverse",
};

export { IconSizes, IconSource, IconSet, IconVariant };